import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ServicesSection from "@/components/ServicesSection";
import Marquee from "@/components/Marquee";
import BrandSection from "@/components/BrandSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import PlaceholderPage from "@/components/PlaceholderPage";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { err: null };
    }
    static getDerivedStateFromError(err) {
        return { err };
    }
    render() {
        if (this.state.err) {
            return (
                <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-ink px-6 text-center">
                    <p className="font-mono-tech text-xs tracking-[0.3em] text-flame">
                        EROARE NEAȘTEPTATĂ
                    </p>
                    <a
                        href="/"
                        className="font-mono-tech text-xs tracking-[0.2em] text-paper underline underline-offset-4"
                    >
                        REÎNCARCĂ PAGINA
                    </a>
                </div>
            );
        }
        return this.props.children;
    }
}

function Home() {
    return (
        <>
            <Hero />
            <ServicesSection />
            <Marquee />
            <BrandSection />
            <FinalCTA />
            <Footer />
        </>
    );
}

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            delete window.__lenis;
        };
    }, []);

    return (
        <BrowserRouter>
            <ErrorBoundary>
                <div className="min-h-screen bg-ink text-paper">
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/carotare" element={<PlaceholderPage />} />
                        <Route
                            path="/demolari-taiere"
                            element={<PlaceholderPage />}
                        />
                        <Route path="/slefuire" element={<PlaceholderPage />} />
                        <Route
                            path="/repastilare-carote"
                            element={<PlaceholderPage />}
                        />
                        <Route path="/contact" element={<PlaceholderPage />} />
                        <Route path="*" element={<PlaceholderPage />} />
                    </Routes>
                    <div aria-hidden="true" className="grain-overlay" />
                </div>
            </ErrorBoundary>
        </BrowserRouter>
    );
}